import { render, staticRenderFns } from "./CourseStatistics.vue?vue&type=template&id=c24eedec&scoped=true"
import script from "./CourseStatistics.vue?vue&type=script&lang=js"
export * from "./CourseStatistics.vue?vue&type=script&lang=js"
import style0 from "./CourseStatistics.vue?vue&type=style&index=0&id=c24eedec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24eedec",
  null
  
)

export default component.exports